import { ChangeEvent, FunctionComponent } from "react";

import Step from "rivals/components/pages/Registration/Steps/Step";
import PromotionInput from "rivals/components/shared/Form/PromotionInput";
import { SubscriptionPlanSelection } from "rivals/components/shared/Subscription/SubscriptionPlan";
import { PLANS, PurchasablePlan } from "rivals/shared/constants";
import styles from "./index.module.scss";
import strings from "./strings";
import { Props } from "./types";

const {
  annualBullets,
  annualCostDescription,
  monthlyBullets,
  monthlyCostDescription,
  title
} = strings;

const ConfirmSubscriptionStep: FunctionComponent<Props> = ({
  annualCostDollars,
  currentSiteName,
  monthlyCostDollars,
  monthlySavings,
  promoCode,
  referAFriendCode,
  selectedPlan,
  selectPlan,
  selectedSite,
  setPromoCode,
  subscribableAddOns,
  stepNumber
}) => {
  function onChange(e: ChangeEvent<HTMLInputElement>): void {
    selectPlan(e.target.value as PurchasablePlan);
  }

  return (
    <Step stepNumber={stepNumber} title={title}>
      <>
        <div className={styles.container}>
          <SubscriptionPlanSelection
            onChange={onChange}
            plans={[
              {
                bullets: annualBullets(currentSiteName),
                cost: annualCostDescription(annualCostDollars),
                planType: PLANS.ANNUAL,
                savings: monthlySavings
              },
              {
                bullets: monthlyBullets(currentSiteName),
                cost: monthlyCostDescription(monthlyCostDollars),
                planType: PLANS.MONTHLY
              }
            ]}
            selectedPlan={selectedPlan}
            subscribableAddOns={subscribableAddOns}
          />
        </div>
        <PromotionInput
          planType={selectedPlan}
          promoCodeValue={promoCode}
          referAFriendCode={referAFriendCode}
          selectedSite={selectedSite}
          setPromoCode={setPromoCode}
        />
      </>
    </Step>
  );
};

export default ConfirmSubscriptionStep;
